import { AXButtonModule } from '@acorex/components/button';
import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXDrawerModule } from '@acorex/components/drawer';
import { AXDropdownModule } from '@acorex/components/dropdown';
import { AXMenuModule } from '@acorex/components/menu';
import { AXPopupService } from '@acorex/components/popup';
import { AXEventService } from '@acorex/core/events';
import { AXTranslationModule, AXTranslationService } from '@acorex/core/translation';
import { CommonModule, DOCUMENT, Location } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PublicLoginComponent, PublicLoginService } from '@travel/public-login';
import { SettingDataOutputModel, UserProfileOutputModel } from '@travel/shared';
import { EventActions } from '@travel/shared/enums';
import { DataConfig, PlatformService, StorageService, ThemeService } from '@travel/shared/services';

@Component({
  selector: 'travel-btc-workspace-hotel-wl-header',
  standalone: true,
  imports: [CommonModule, RouterModule, AXButtonModule, AXDropdownModule, AXDecoratorModule, AXTranslationModule, AXMenuModule, AXDrawerModule],
  templateUrl: './hotel-wl-header.component.html',
  styleUrls: ['./hotel-wl-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HotelHeaderComponent {
  protected translateService = inject(AXTranslationService);

  @ViewChild('header', { static: false }) header!: ElementRef<HTMLHeadElement>;
  eventService: AXEventService = inject(AXEventService);

  userProfile: UserProfileOutputModel = {};

  HeaderType: 'main' | 'child' = 'main';
  languageId: any;
  isMobile = false;
  language: string;
  selectedLanguage!: string;
  routeHeader: any;

  env: string = this.environment.picturesURL;

  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  languageList: any[] = [
    {
      code: 'fa',
      title: 'فارسی',
    },
    {
      code: 'en',
      title: 'English',
    },
    {
      code: 'ar',
      title: 'العربية',
    },
  ];

  private _axConfig: any;
  constructor(
    private _popupService: AXPopupService,
    protected storageService: StorageService,
    private _router: Router,
    protected themeService: ThemeService,
    protected _platfromService: PlatformService,
    private _publicLoginService: PublicLoginService,
    private location: Location,
    @Inject('AppConfigService') axConfig: any,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject('environment') private environment: any
  ) {
    // this.userProfile = storageService.get('USER_PROFILE');

    this._axConfig = axConfig;
    this.isMobile = this._platfromService.isPlatform() || false;
    this.language = _platfromService.siteLanguage();
    // this.sloganType();
    // this._loginService.refresh();
  }

  ngOnInit(): void {
    this._publicLoginService.currentUser.subscribe((loggedIn) => {
      this.userProfile = loggedIn;
    });
  }

  goToUrl() {
    if (this.settingData.baseUrl) {
      const externalUrl = this.settingData.baseUrl.startsWith('htttp') ? this.settingData.baseUrl : `http://${this.settingData.baseUrl}`;
      this.document.location.href = externalUrl;
    } else {
      this._router.navigate(['/' + this._platfromService.siteLanguage()]);
    }
  }
  // مشخص نمودن نوع شعار سایت
  // sloganType() {
  //   this._router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((event) => {
  //     // if (event.url === '/' || event.url === '/fa' || event.url === '/ar' || event.url === '/en') {
  //     if (event.url.split('/').length <= 2) {
  //       this.HeaderType = 'main';
  //       if (isPlatformBrowser(this.platformId)) {
  //         this.headerSticky();
  //       }
  //     } else {
  //       this.HeaderType = 'child';
  //     }
  //   });
  // }

  headerSticky() {
    // document.addEventListener('scroll', () => {
    //   const { offsetTop, classList } = this.header.nativeElement;
    //   const classes = ['sticky-state'];
    //   // if (this.HeaderType === 'main') {
    //   //   if (offsetTop > 150) {
    //   //     classList.add(...classes);
    //   //   } else {
    //   //     classList.remove(...classes);
    //   //   }
    //   // }
    // });
  }

  _handleOnItemClick(event: any) {
    switch (event.name) {
      case 'profile':
        this._router.navigate([this._platfromService.siteLanguage() + '/account/account-info']);
        break;
      case 'reserve-list':
        if (!this.isMobile) {
          this._router.navigate([this._platfromService.siteLanguage() + '/account/reservations']);
        } else {
          this._router.navigate([this._platfromService.siteLanguage() + '/account']);
        }
        break;
      case 'account':
        if (this.isMobile) {
          this._router.navigate([this._platfromService.siteLanguage() + '/account']);
        }
        break;
      case 'logout':
        this.storageService.remove('USER_PROFILE');
        this.userProfile = this.storageService.get('USER_PROFILE');
        this.location.replaceState(this._platfromService.siteLanguage());
        document.location.reload();
        break;
      case 'fa':
        this.selectedLanguage = 'Fa';
        this.location.replaceState('/fa');
        this._axConfig.load();
        document.location.reload();
        break;
      case 'en':
        this.selectedLanguage = 'En';

        this.location.replaceState('/en');
        this._axConfig.load();
        document.location.reload();

        break;
      case 'ar':
        this.selectedLanguage = 'Ar';
        this.location.replaceState('/ar');
        this._axConfig.load();
        document.location.reload();
        break;
      default:
        break;
    }
  }

  // لاگین
  loginPopup() {
    this._popupService
      .open(PublicLoginComponent, {
        // ورود به حساب کاربری
        title: this.translateService.translateSync('profile.loginForm'),
        size: 'sm',
      })
      .then((isLogin) => {
        if (isLogin) {
          this.userProfile = this.storageService.get('USER_PROFILE');
        }
      });
  }

  // تغییر زبان سایت
  changeLanguage() {
    this.location.replaceState(this._platfromService.siteLanguage());
    document.location.reload();
  }

  cityList = [
    {
      title: this.translateService.translateSync('city.terhran'),
      url: this.translateService.translateSync('city.terhran-url'),
    },
    {
      title: this.translateService.translateSync('city.kish'),
      url: this.translateService.translateSync('city.kish-url'),
    },
    {
      title: this.translateService.translateSync('city.esfahan'),
      url: this.translateService.translateSync('city.esfahan-url'),
    },
    {
      title: this.translateService.translateSync('city.shiraz'),
      url: this.translateService.translateSync('city.shiraz-url'),
    },
    {
      title: this.translateService.translateSync('city.rasht'),
      url: this.translateService.translateSync('city.rasht-url'),
    },
    {
      title: this.translateService.translateSync('city.ramsar'),
      url: this.translateService.translateSync('city.ramsar-url'),
    },
    {
      title: this.translateService.translateSync('city.yazd'),
      url: this.translateService.translateSync('city.yazd-url'),
    },
  ];

  handleMenuItemClick(city: any) {
    this._router.navigate([city]);
  }
  handleHamburgerClick() {
    this.eventService.broadcast(EventActions.toggleDrawerMenu);
  }
}
